export default "__VITE_ASSET__DJliBeh___"